import CompetitionsResult from './CompetitionsResult';
import { connect } from 'react-redux'

export default connect(
  ( { competition : { model = null, loadingItem} } ) => ({
    model,
    loading: loadingItem
  }),
)(CompetitionsResult)



// WEBPACK FOOTER //
// ./src/components/Competitions/CompetitionResult/index.js